/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { PaymentMethodID } from './payment-method-model';
import { SaleID } from './sale-model';
import { PaymentMethodType } from '../types/utils';

export class CreateInvestmentInput {
	amountShares: number = 0

	investingForThemselves: boolean = false

	paymentMethodId: PaymentMethodID = ''

	paymentMethodType: PaymentMethodType = PaymentMethodType.WIRE_TRANSFER

	saleId: SaleID = ''

	selfDisclosedAvailableCash?: boolean

	selfDisclosedMonthlyNetSalary?: boolean
}